import { c as _c } from "react/compiler-runtime";
// Шаг «Разбор»: этапы с подписями, done/total, сообщение шлюза и живой
// расход (токены, $). Опрос раз в 2 с ведёт хук задания.
import { Check, Circle, CircleX, Loader2 } from "lucide-react";
import { CATALOG_IMPORT_STAGE_LABELS, type CatalogImportJobDetail, type CatalogImportStage } from "@osmix/contracts";
import { useCatalogImportModels } from "@/api/hooks/use-catalog-import";
import { Button } from "@osmix/ui/button";
import { cn } from "@/lib/utils";
import { ProgressBar, StatTile, formatTokens, formatUsd } from "./shared";
const PARSE_STAGES: CatalogImportStage[] = ["extract", "structure", "photos", "categories", "validate"];
const MODE_LABEL = {
  template: "по шаблону, без модели",
  ai: "моделью",
  mixed: "шаблон + модель"
} as const;
export function ParseStep(t0) {
  const $ = _c(54);
  const {
    job,
    canEdit,
    onCancel
  } = t0;
  const running = job.status === "parsing";
  const failed = job.status === "failed";
  const finished = !running && !failed;
  let t1;
  if ($[0] !== failed || $[1] !== job.progress || $[2] !== running) {
    t1 = running || failed ? PARSE_STAGES.indexOf(job.progress.stage ?? "extract") : PARSE_STAGES.length;
    $[0] = failed;
    $[1] = job.progress;
    $[2] = running;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentIndex = t1;
  const model = useCatalogImportModels().data?.models.find(m => m.id === job.model);
  const t2 = "flex flex-col gap-4";
  const t3 = running ? "\u041C\u043E\u0434\u0435\u043B\u044C \u0440\u0430\u0437\u0431\u0438\u0440\u0430\u0435\u0442 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B" : failed ? "\u0420\u0430\u0437\u0431\u043E\u0440 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u043B\u0441\u044F" : "\u0420\u0430\u0437\u0431\u043E\u0440 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D";
  let t4;
  if ($[4] !== t3) {
    t4 = <h2 className="text-lg font-semibold">{t3}</h2>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = running ? "\u0420\u0430\u0437\u0431\u043E\u0440 \u0438\u0434\u0451\u0442 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u2014 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043C\u043E\u0436\u043D\u043E \u0443\u0439\u0442\u0438 \u0438 \u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u043D\u0438\u0439." : finished ? `Позиций: ${job.items.length}${job.mode ? ` · разобрано ${MODE_LABEL[job.mode]}` : ""}` : "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438 \u2014 \u0432 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438 \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0435 \u0432\u044B\u0448\u0435.";
  let t6;
  if ($[6] !== t5) {
    t6 = <p className="text-sm text-muted-foreground">{t5}</p>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="min-w-0">{t4}{t6}</div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== canEdit || $[12] !== onCancel || $[13] !== running) {
    t8 = running && canEdit && <Button variant="outline" onClick={onCancel}>Отменить</Button>;
    $[11] = canEdit;
    $[12] = onCancel;
    $[13] = running;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="mb-4 flex flex-wrap items-start justify-between gap-3">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== currentIndex || $[19] !== failed || $[20] !== job.progress || $[21] !== running) {
    t10 = PARSE_STAGES.map((stage, index) => {
      const done = index < currentIndex;
      const current = index === currentIndex && running;
      const broken = index === currentIndex && failed;
      return <li key={stage} className="flex gap-3"><span className="mt-0.5 grid size-5 shrink-0 place-items-center">{done ? <span className="grid size-5 place-items-center rounded-full bg-primary text-primary-foreground"><Check className="size-3" /></span> : current ? <Loader2 className="size-5 animate-spin text-primary" /> : broken ? <CircleX className="size-5 text-destructive" /> : <Circle className="size-5 text-muted-foreground/40" />}</span><div className="min-w-0 flex-1"><div className="flex flex-wrap items-baseline justify-between gap-x-3"><span className={cn("text-sm", (current || broken) && "font-medium", !done && !current && !broken && "text-muted-foreground")}>{CATALOG_IMPORT_STAGE_LABELS[stage]}</span>{current && job.progress.total > 0 && <span className="text-xs text-muted-foreground tabular-nums">{job.progress.done} из {job.progress.total}</span>}</div>{current && <div className="mt-1.5 space-y-1"><ProgressBar value={job.progress.done} max={Math.max(1, job.progress.total)} />{job.progress.message && <p className="truncate text-xs text-muted-foreground" aria-live="polite">{job.progress.message}</p>}</div>}</div></li>;
    });
    $[18] = currentIndex;
    $[19] = failed;
    $[20] = job.progress;
    $[21] = running;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <ol className="flex flex-col gap-3">{t10}</ol>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t9) {
    t12 = <section className="rounded-lg border p-4 sm:p-6">{t9}{t11}</section>;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== job.usage.costUsd) {
    t13 = formatUsd(job.usage.costUsd);
    $[28] = job.usage.costUsd;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = <StatTile label={"\u041F\u043E\u0442\u0440\u0430\u0447\u0435\u043D\u043E"} value={t13} />;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== job.usage.tokensIn) {
    t15 = formatTokens(job.usage.tokensIn);
    $[32] = job.usage.tokensIn;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15) {
    t16 = <StatTile label={"\u0422\u043E\u043A\u0435\u043D\u043E\u0432 \u043D\u0430 \u0432\u0445\u043E\u0434\u0435"} value={t15} />;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== job.usage.tokensOut) {
    t17 = formatTokens(job.usage.tokensOut);
    $[36] = job.usage.tokensOut;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <StatTile label={"\u0422\u043E\u043A\u0435\u043D\u043E\u0432 \u043D\u0430 \u0432\u044B\u0445\u043E\u0434\u0435"} value={t17} />;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== job.usage.calls) {
    t19 = <StatTile label={"\u0417\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u043A \u043C\u043E\u0434\u0435\u043B\u0438"} value={job.usage.calls} />;
    $[40] = job.usage.calls;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t14 || $[43] !== t16 || $[44] !== t18 || $[45] !== t19) {
    t20 = <section className="grid grid-cols-2 gap-3 sm:grid-cols-4" aria-live="polite">{t14}{t16}{t18}{t19}</section>;
    $[42] = t14;
    $[43] = t16;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const t21 = "text-xs text-muted-foreground";
  const t22 = "\u041C\u043E\u0434\u0435\u043B\u044C: ";
  const t23 = model?.label ?? job.model;
  const t24 = model ? ` · ${formatUsd(model.priceIn)} / ${formatUsd(model.priceOut)} за 1 млн токенов` : "";
  let t25;
  if ($[47] !== t23 || $[48] !== t24) {
    t25 = <p className={t21}>{t22}{t23}{t24}</p>;
    $[47] = t23;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t12 || $[51] !== t20 || $[52] !== t25) {
    t26 = <div className={t2}>{t12}{t20}{t25}</div>;
    $[50] = t12;
    $[51] = t20;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
}